import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/location.png'


const _withScopeId = n => (_pushScopeId("data-v-5d45f81c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-[1200px] mx-auto py-[60px] px-60px box-sizing webzcfg" }
const _hoisted_2 = { class: "flex py-[20px] text-[14px] text-[#606266]" }
const _hoisted_3 = { class: "path" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "location",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "当前位置:", -1))

import PageList from "@/components/PageList/ListComp.vue";
import { defineOptions, ref, watch } from "vue";
import useNavigation from "@/hooks/useNavigation";
import useCurName from "@/hooks/useCurMenu";

export default /*#__PURE__*/_defineComponent({
  ...{
  name: "PoliciesView",
},
  __name: 'PoliciesView',
  setup(__props) {

const { push } = useNavigation();
const { name } = useCurName("/policies");
function goDetail({ id }) {
  push({
    path: "/policies/detail",
    query: {
      id,
    },
  });
}


return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("span", null, [
          _createVNode(_component_el_link, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(push)('/')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("首页")
            ]),
            _: 1
          }),
          _createTextVNode(" > " + _toDisplayString(_unref(name)), 1)
        ])
      ])
    ])
  ]))
}
}

})